

export default {
  mounted() {
    const toolbar = [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      [{'direction': 'rtl'}],
      ['link'],
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      [{'align': []}],
      ['clean'],
    ]
    const editors = document.querySelectorAll('.ql-input')

    editors.forEach((element) => {
      const quillInstance = Quill.find(element);

      if (quillInstance === null) {
        const key = element.dataset.key
        const editor = new Quill(element, {
          modules: {toolbar},
          theme: 'snow',
        });

        editor.on('text-change', () => {
          const value = editor.root.innerHTML;

          this.pushEvent(`update_${key}`, value);
        });

        this.handleEvent(`update_${key}`, (value) => {
          this.pushEventTo(`#${ element.id}`, `set_${key}`, {value});
        });

        this.handleEvent(`set_${key}`, ({value}) => {
          editor.root.innerHTML = value;
        });
      }

    });
  },
}
